module.exports = __webpack_public_path__ + "static/media/devsecops_1.f4ea4fb3.svg";